import React from "react";
import {
  Image,
  Form,
  OverlayTrigger,
  Tooltip,
  Button,
  Modal
} from "react-bootstrap";
import {
  isValidArray,
  setLocalstorage,
  searchByValueHelper,
  FormDataForImage,
  truncateData,
  dateFormat
} from "../../../../helper";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import Add_Notifications from "../../../../assets/notification_icon.svg";
import Edit_Icon from "../../../../assets/edit-image.svg";
import Delete_Icon from "../../../../assets/delete-image.svg";
import ImageBackground from "../../../../assets/ImageBackground.svg";
import CancleIcon from "../../../../assets/CancelIcon.svg";
import { TableTemplate } from "../../../reusableComponent/tableListing/cmstemplate";
import IconPlus from "../../../../assets/Files-icon.svg";
import Files from "react-files";
import { DatePicker } from "../../../../component";
import { get } from "lodash";
import { LoaderPage } from "../../../../component/Loader";
import { ConfirmationComponent } from "../../../ConfirmationComponent";
import {
  ERROR_MSG,
  STATUS,
  FILE_FORMATS,
  FILE_FORMAT,
  FILE_SIZE_LIMIT
} from "../../../../constant";
import { successToastStyle, errorToastStyle } from "../../../../customToast";
import { toast } from "react-toastify";
import {
  getNotificationsLists,
  uploadFile,
  addNotifications,
  notificationsOrder,
  deleteNotificationAPI,
  updateNotifications
} from "../../../../services/apiServices";
import request from "../../../../services/requestService";
import NoDataFound from "../../../../component/NoDataFound";
import { LoaderTemplate } from "../../tableListing/loaderTemplate";
export default class Notification extends React.Component {
  constructor(props) {
    super(props);
    this.notificationModelRef = React.createRef();
    this.state = {
      notificationsData: [],
      displayModal: false,
      selectedImage: null,
      isEdit: false,
      selectedDate: null,
      errors: {},
      deleteshowAlert: false,
      saveshowAlert: false,
      title: "",
      extension: null,
      count: 0,
      files: [],
      isLoading: true,
      displayLoader: false,
      deleteId: "",
      dataUnsaved: false,
      allowPrompt: true,
      isActive: true,
      editId: ""
    };
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
    this.getAllNotifications(this.state.isActive);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  handleClickOutside = event => {
    // const { togglePopUp } = this.props;
    const { dataUnsaved, allowPrompt } = this.state;

    // Check if the click was outside the modal
    const modalRef =
      this.notificationModelRef && this.notificationModelRef.current;
    const isOutsideModal = modalRef && !modalRef.contains(event.target);

    // Check if the click was on the vertical scrollbar
    const isClickOnScrollbar =
      event.clientX > window.innerWidth - 7 &&
      (event.clientY >= 0 && event.clientY <= window.innerHeight);

    // If the click is outside the modal and not on the scrollbar
    if (isOutsideModal && !isClickOnScrollbar) {
      if (dataUnsaved && allowPrompt && event.button === 0) {
        event.preventDefault();
        const confirmLeave = window.confirm(
          "You have unsaved changes, are you sure you want to leave?"
        );

        if (confirmLeave) {
          this.setState(prevState => ({
            displayModal: !prevState.displayModal
          }));
          return;
        }
      }
    }
  };
  getAllNotifications = async (activeBoolean, flag) => {
    try {
      this.setState({ isLoading: !flag ? true : false });

      const response = await request(getNotificationsLists(activeBoolean));

      if (response && response.data && response.data.data) {
        const apiData = response.data.data;
        const notificationsData = apiData.map(item => {
          const fileObj = item.file && item.file.length > 0 ? item.file[0] : {};
          return {
            id: item.id,
            title: item.title,
            active: item.active,
            letterdate: item.letterDate || "",

            // File data
            fileId: fileObj.id || "",
            filename: fileObj.title || "",
            fileUrl: fileObj.s3Url || ""
          };
        });

        this.setState({
          notificationsData,
          isLoading: false,
          displayLoader: false
        });
      } else {
        this.setState({ isLoading: false, displayLoader: false });
      }
    } catch (error) {
      console.error("Fetch Error:", error);

      this.setState({ isLoading: false });

      toast.error(
        <p className="toast-text-alignment">
          {error.message || "Failed to load notifications"}
        </p>,
        errorToastStyle
      );
    }
  };
  handleRemoveImage = () => {
    if (this.state.selectedImage) {
      this.setState({
        selectedImage: null,
        extension: null,
        count: [],
        dataUnsaved: true
      });

      toast.success(
        <p className="toast-text-alignment">File Removed Successfully</p>,
        successToastStyle
      );
    }
  };
  onFilesError = file => {
    if (file && file.message) {
      if (file.message.includes("too large")) {
        this.setState({ isLoading: false });
        toast.error(
          <p className="toast-text-alignment">
            The File Exceeds The Maximum Size Limit Of 10MB
          </p>,
          errorToastStyle
        );
      } else if (file.message.includes("valid file type")) {
        toast.error(
          <p className="toast-text-alignment">Invalid File Type</p>,
          errorToastStyle
        );
      } else {
        toast.error(
          <p className="toast-text-alignment">{file.message}</p>,
          errorToastStyle
        );
      }
    }
    this.inValidFile = true;
  };
  onFilesChange = async file => {
    try {
      if (!this.inValidFile) {
        if (!file || !file.length) return;

        // Only PDF
        if (file[0].extension !== "pdf") {
          toast.error("Only PDF allowed");
          return;
        }

        const attachmentPayload = FormDataForImage(file, "file");
        attachmentPayload.append("isMis", false);

        this.setState({ isLoading: true });
        const response = await request(uploadFile(attachmentPayload));

        if (response) {
          const { status, message, data } = response;
          if (status) {
            const { errors } = this.state;

            this.setState(prev => ({
              count: data.data.id,
              selectedImage: data.data.name,
              isLoading: false,
              extension: "pdf",
              files: prev.files.concat({
                ...data,
                extension: "pdf"
              }),
              dataUnsaved: true,

              errors: {
                ...prev.errors,
                ...(errors.selectedImage && errors.selectedImage.error
                  ? {
                      selectedImage: {
                        error: false,
                        message: ""
                      }
                    }
                  : {})
              }
            }));

            toast.success(
              <p className="toast-text-alignment">{data.message}</p>,
              successToastStyle
            );
          } else {
            // toast.error(message);
            toast.error(
              <p className="toast-text-alignment">{data.message}</p>,
              errorToastStyle
            );
          }
        } else {
          //toast.error(ERROR_MSG.DEFAULT_MSG_FOR_REPONSE_ERROR);
          toast.error(
            <p className="toast-text-alignment">
              {ERROR_MSG.DEFAULT_MSG_FOR_REPONSE_ERROR}
            </p>,
            errorToastStyle
          );
        }
      }

      this.inValidFile = false;
    } catch (e) {
      console.error(e);

      toast.error(e.message, errorToastStyle);
    }
  };

  onDragEnd = async result => {
    if (!result.destination) return;

    try {
      const items = Array.from(this.state.notificationsData);

      // Reorder
      const [movedItem] = items.splice(result.source.index, 1);
      items.splice(result.destination.index, 0, movedItem);

      // Build payload
      const payload = {};

      items.forEach((item, index) => {
        const dateObj = new Date(item.letterdate);

        const formattedDate = `${dateObj.getFullYear()}-${String(
          dateObj.getMonth() + 1
        ).padStart(2, "0")}-${String(dateObj.getDate()).padStart(2, "0")}`;

        payload[index] = {
          id: item.id,
          title: item.title,
          letterDate: formattedDate,
          active: item.active,
          file: [item.fileId],
          displayOrder: index + 1
        };
      });

      // Update UI
      this.setState({
        notificationsData: items
      });

      // API call
      await request(notificationsOrder(payload));
    } catch (error) {
      console.error("Order update failed:", error);
    }
  };

  onToggleModal = (data = {}) => {
    this.setState({
      title: data.title || "",

      selectedDate: data.letterdate ? new Date(data.letterdate) : null,

      selectedImage: data.filename || "",
      count: data.fileId ? [data.fileId] : [],

      isEdit: !!data.id,
      editId: data.id,
      extension: "pdf",
      dataUnsaved: false,
      errors: {}
    });

    this.setState(prevState => ({
      displayModal: !prevState.displayModal
    }));
  };

  onDeleteRecord = (id, e) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ deleteshowAlert: true, deleteId: id });
  };

  onSaveRecord = e => {
    e.preventDefault();
    e.stopPropagation();

    const { title, selectedDate, selectedImage } = this.state;
    let errors = {};

    // Title validation
    if (!title || title.trim() === "") {
      errors.title = {
        error: true,
        message: "This field is required."
      };
    }

    // Date validation
    if (!selectedDate) {
      errors.selectedDate = {
        error: true,
        message: "This field is required."
      };
    }

    // File validation
    if (!selectedImage) {
      errors.selectedImage = {
        error: true,
        message: "This field is required."
      };
    }

    // If errors → stop here
    if (Object.keys(errors).length > 0) {
      this.setState({ errors });

      toast.error(
        <p className="toast-text-alignment">{ERROR_MSG.INVALID_FORM}</p>,
        errorToastStyle
      );

      return;
    }

    this.setState(prevState => ({
      saveshowAlert: !prevState.saveshowAlert,
      allowPrompt: false
    }));
  };

  openConfirmationAlert = e => {
    this.setState(prevState => ({
      deleteshowAlert: !prevState.deleteshowAlert,
      allowPrompt: false
    }));
  };
  handleConfirmationAlert = e => {
    if (!this.state.allowPrompt) {
      this.setState(prevState => ({
        saveshowAlert: !prevState.saveshowAlert,
        allowPrompt: true
      }));
    } else {
      this.setState(prevState => ({
        saveshowAlert: !prevState.saveshowAlert,
        allowPrompt: false
      }));
    }
  };
  deleteNotification = async () => {
    const { deleteId } = this.state; // store id when opening modal

    if (!deleteId) return;

    try {
      // Start loader
      this.setState({ isLoading: true });

      const payload = {
        id: deleteId
      };

      // Call API
      const response = await request(deleteNotificationAPI(payload));

      if (response && response.data.status) {
        toast.success(
          <p className="toast-text-alignment">{response.data.message}</p>,
          successToastStyle
        );
        this.setState({
          displayLoader: true,
          deleteshowAlert: false,
          deleteId: null
        });
        // Refresh list
        this.getAllNotifications(this.state.isActive); // or componentDidMount()
      } else {
        toast.error(
          <p className="toast-text-alignment">{response.data.message}</p>,
          errorToastStyle
        );
      }
    } catch (error) {
      toast.error(
        <p className="toast-text-alignment">Something went wrong</p>,
        errorToastStyle
      );
    } finally {
      // Stop loader
      this.setState({ isLoading: false });
    }
  };
  handleSave = () => {
    this.submitForm();

    // Close modal after save
    this.setState({
      saveshowAlert: false,
      allowPrompt: false
    });
  };

  submitForm = async () => {
    try {
      this.setState({ isLoading: true });

      const {
        title,
        selectedDate,
        count,
        isActive,
        isEdit,
        editId
      } = this.state;
      let letterDate = "";
      if (selectedDate) {
        const d = selectedDate;
        letterDate = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(
          2,
          "0"
        )}-${String(d.getDate()).padStart(2, "0")}`;
      }

      // Prepare Payload
      const payload = {
        title: title.trim(),
        letterDate,
        active: isActive,
        file: isEdit && Array.isArray(count) ? count : [count]
      };

      // API Call
      const response = editId
        ? await request(updateNotifications(payload, editId))
        : await request(addNotifications(payload));

      if (response && response.data.status) {
        toast.success(
          <p className="toast-text-alignment">{response.data.message}</p>,
          successToastStyle
        );

        this.setState({
          title: "",
          selectedDate: null,
          selectedImage: null,
          count: null,
          files: [],
          dataUnsaved: false,
          errors: {},
          displayLoader: true,
          saveshowAlert: false
        });
        this.getAllNotifications(this.state.isActive);
      } else {
        toast.error(
          <p className="toast-text-alignment">
            {(response && response.data.message) || "Something went wrong"}
          </p>,
          errorToastStyle
        );
      }
    } catch (error) {
      console.error("Submit Error:", error);

      toast.error(
        <p className="toast-text-alignment">
          {error.message || "Server Error"}
        </p>,
        errorToastStyle
      );
    } finally {
      this.setState({ isLoading: false, displayModal: false });
    }
  };

  handleChange = e => {
    e.preventDefault();
    e.stopPropagation();

    const { value } = e.target;
    const { errors } = this.state;

    if (value.length > 75) {
      return;
    }

    // Remove error if exists
    if (errors.title && errors.title.error) {
      this.setState(prev => ({
        errors: {
          ...prev.errors,
          title: {
            error: false,
            message: ""
          }
        }
      }));
    }

    this.setState({
      title: value,
      dataUnsaved: true,
      allowPrompt: true
    });
  };
  handleDateChange = date => {
    const { errors } = this.state;

    // Clear date error if exists
    if (errors.selectedDate && errors.selectedDate.error) {
      this.setState(prev => ({
        errors: {
          ...prev.errors,
          selectedDate: {
            error: false,
            message: ""
          }
        }
      }));
    }

    this.setState({
      selectedDate: date,
      dataUnsaved: true
    });
  };
  handleActiveChange = () => {
    this.setState(
      prev => ({
        isActive: !prev.isActive,
        displayLoader: true
      }),
      () => {
        this.getAllNotifications(this.state.isActive, true);
      }
    );
  };

  render() {
    const {
      displayLoader,
      notificationsData,
      displayModal,
      isEdit,
      selectedDate,
      errors,
      deleteshowAlert,
      title,
      isLoading,
      isActive,
      saveshowAlert
    } = this.state;
    // console.log(this.props.dragandDropAccess)
    return (
      <React.Fragment>
        <LoaderPage loading={isLoading} />

        <div class="pmg-management pmg-listing">
          <div class="header ">
            <div class="d-flex flex-row">
              <div class="d-flex gap-2">
                <h3 class="mt-2">Notifications</h3>&nbsp;
                <span className="notifications-count-text">
                  {notificationsData.length == 0 ? null : (
                    <>({notificationsData.length})</>
                  )}
                </span>
              </div>

              {/**<Form.Check
                className={`form-checkbox ${isActive ? "checked" : ""}`}
                style={{ paddingLeft: 35 }}
              >
                <Form.Check.Input type="checkbox" />

                <Form.Check.Label
                  className="d-flex active-check-mark"
                  checked={isActive}
                  onClick={e => {
                    this.handleActiveChange(e);
                  }}
                >
                  <div className={`active-check-label ${isActive}`}>
                    ACTIVE NOTIFICATIONS
                  </div>
                </Form.Check.Label>
              </Form.Check> */}
            </div>
            <div class="header-buttons d-flex flex-row">
              <OverlayTrigger
                trigger="hover"
                defaultShow={false}
                placement="bottom"
                overlay={
                  <Tooltip
                    id={`tooltip-checking`}
                    className="create_project_tolltip"
                  >
                    Add New Notification
                  </Tooltip>
                }
              >
                <Button
                  className={`btn-orange create-btn 
                }`}
                  size="sm"
                  onClick={e => {
                    e.preventDefault();
                    e.stopPropagation();
                    this.onToggleModal(e);
                  }}
                >
                  <div>
                    <Image src={Add_Notifications} className="create-user" />
                  </div>
                </Button>
              </OverlayTrigger>
            </div>
          </div>

          <ConfirmationComponent
            show={saveshowAlert}
            modalClass={"confirmation-modal notification-delete"}
            saveHandler={() => {
              this.handleSave();
            }}
            closeHandler={e => {
              this.handleConfirmationAlert(e);
            }}
            content={"Are you sure you want to do this?"}
          />
          <ConfirmationComponent
            show={deleteshowAlert}
            modalClass={"confirmation-modal notification-delete"}
            saveHandler={() => {
              this.deleteNotification();
            }}
            closeHandler={e => {
              this.openConfirmationAlert(e);
            }}
            content={"Are you sure you want to delete this notification?"}
          />
          <Modal
            size="lg"
            show={displayModal}
            onHide={e => {
              this.onToggleModal(e);
            }}
            aria-labelledby="example-modal-sizes-title-lg"
            className="content-modal  create-user-form"
          >
            <div className="modal-box-shadow" ref={this.notificationModelRef}>
              <Modal.Header closeButton className="header-modal">
                <Modal.Title id="example-modal-sizes-title-lg">
                  Add Notification
                </Modal.Title>
              </Modal.Header>
              <Modal.Body className="body-modal-cms  create-user-body-modal">
                <Form.Label className="label-style">
                  Title
                  <span className="required">*</span>
                </Form.Label>
                <Form.Control
                  name="name"
                  type="text"
                  value={title}
                  maxLength={75}
                  onChange={e => {
                    e.preventDefault();
                    e.stopPropagation();
                    this.handleChange(e);
                    // this.validateField("name", e.target.value);
                  }}
                  //onBlur={() => this.validateField("name", name)}
                  isInvalid={errors.title && errors.title.error}
                  placeholder="Enter Title"
                  className="addFormText"
                  //  className={`${isEdit ? "field-width-cms" : "addFormText "}`}
                />
                {errors.title && errors.title.error ? (
                  <div class="error-text mt-1">
                    {get(errors, "title.message", null)}
                  </div>
                ) : null}

                <Form.Label
                  className="label-style"
                  style={{ paddingTop: "24px" }}
                >
                  Letter Date
                  <span className="required">*</span>
                </Form.Label>
                <DatePicker
                  name="selectedDate"
                  startDate={new Date()}
                  onChange={this.handleDateChange}
                  placeholderText="DD/MM/YYYY"
                  selected={selectedDate}
                  value={selectedDate}
                  isInvalid={errors.selectedDate && selectedDate == null}
                  //  wrapperClassName={
                  //   errors.selectedDate && selectedDate == null
                  //     ? "date-invalid-wrapper"
                  //     : ""
                  // }
                  // className={`releaseDate ${
                  //   isEdit ? "field-width-cms" : " addFormText"
                  // } `}
                  className="releaseDate addFormText"
                />
                {errors.selectedDate && (
                  <div className="error-text mt-1">
                    {errors.selectedDate.message}
                  </div>
                )}

                <Form.Group controlId="file" style={{ paddingTop: "16px" }}>
                  <Form.Label className="label-style">
                    Upload Notification Document
                    <span className="required">*</span>
                  </Form.Label>

                  {this.state.selectedImage ? (
                    <div className="d-flex showImage">
                      <div
                        className="d-flex flex-column justify-content-center align-items-center imgIcon"
                        style={{ backgroundImage: `url(${ImageBackground})` }}
                      >
                        <p className="text-white text-uppercase mt-4 iconText">
                          {this.state.extension !== null
                            ? this.state.extension
                            : ""}
                        </p>
                      </div>
                      <div className="image uploadedPhoto">
                        {this.state.selectedImage.length > 20
                          ? this.state.selectedImage
                              .split(".", 1)[0]
                              .substr(0, 20) + "..."
                          : this.state.selectedImage.split(".", 1)[0]}
                      </div>
                      <div className="d-flex align-items-start imageUploaded">
                        <img
                          className="cancelImg"
                          src={CancleIcon}
                          alt="Cancel_Icon"
                          onClick={this.handleRemoveImage}
                        />
                      </div>
                    </div>
                  ) : (
                    <div>
                      {" "}
                      <Files
                        onChange={this.onFilesChange}
                        onError={this.onFilesError}
                        multiple={false}
                        accepts={FILE_FORMAT}
                        maxFileSize={FILE_SIZE_LIMIT.OTHER_FORMATS}
                        className="best-practices-add-files cms-add-files"
                        data-test="add-files"
                        clickable
                        convertToBase64={false}
                      >
                        <div>
                          <Image
                            src={IconPlus}
                            className="addFile_plus"
                            alt="Plus Icon"
                          />
                          <div
                            className="add-file-text pt-2"
                            data-test="label-add-document"
                          >
                            Add
                          </div>
                        </div>
                      </Files>
                      <p className="add-file-subtext font-semibold pt-1 mb-0 font-italic-cms">
                        Supported File type: .pdf <br />
                        Max size: 10MB
                      </p>
                      {errors.selectedImage && (
                        <div className="error-text mt-1">
                          {errors.selectedImage.message}
                        </div>
                      )}
                    </div>
                  )}
                </Form.Group>
                <div>
                  <Button
                    className="btn-orange cms-edit-create-btn rounded mt-3 mb-3"
                    onClick={e => {
                      e.preventDefault();
                      e.stopPropagation();
                      this.onSaveRecord(e);
                    }}
                  >
                    {isEdit ? "UPDATE" : "ADD"}
                  </Button>
                </div>
              </Modal.Body>
            </div>
          </Modal>
          <div className="notifications-table-wrapper">
            <DragDropContext onDragEnd={this.onDragEnd}>
              <table
                className="admin-table-container-cms  pmg-table table notification-table table-sm table-striped table-hover"
                style={{ marginBottom: "0rem" }}
              >
                {/* HEADER */}
                <thead className="no-sort-icon pmg-table-header">
                  <tr>
                    <th>S No.</th>
                    <th>Title</th>
                    <th>Letter Date</th>
                    <th>File Name</th>
                    <th>Action</th>
                  </tr>
                </thead>

                {/* BODY */}
                {/* <Droppable droppableId="notification-table">
                  {provided => (
                    <tbody
                      ref={provided.innerRef}
                      {...provided.droppableProps}
                      className="users-table-body"
                    >
                      {displayLoader ? (
                        <tr align="center" className="table-loader">
                          <td colSpan="5">
                            <LoaderTemplate />
                          </td>
                        </tr>
                      ) : (
                        <>
                          {notificationsData.length == 0 ? (
                            <tr align="center">
                              <td colSpan="5">
                                <NoDataFound />
                              </td>
                            </tr>
                          ) : (
                            <>
                              {notificationsData.map((item, index) => (
                                <Draggable
                                  key={item.id || index}
                                  draggableId={(item.id || index).toString()}
                                  index={index}
                                >
                                  {(provided, snapshot) => {
                                    const style = {
                                      ...provided.draggableProps.style
                                    };

                                    return (
                                      <tr
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                        className={
                                          snapshot.isDragging
                                            ? "dragging-row"
                                            : ""
                                        }
                                        style={style}
                                      >
                                        <td className="col-sno">{index + 1}</td>

                                        <td className="col-title">
                                          {item.title}
                                        </td>

                                        <td className="col-date">
                                          {dateFormat(item.letterdate)}
                                        </td>

                                        <td className="col-file">
                                          <a
                                            href={item.fileUrl}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                          >
                                            {item.filename}
                                          </a>
                                        </td>

                                        <td className="col-action">
                                          <img
                                            src={Edit_Icon}
                                            alt="edit"
                                            className="notifications-edit-icon"
                                            onClick={() =>
                                              this.onToggleModal(item)
                                            }
                                          />

                                          <img
                                            src={Delete_Icon}
                                            alt="delete"
                                            className="notifications-delete-icon"
                                            onClick={e => {
                                              e.preventDefault();
                                              e.stopPropagation();
                                              this.onDeleteRecord(item.id, e);
                                            }}
                                          />
                                        </td>
                                      </tr>
                                    );
                                  }}
                                </Draggable>
                              ))}
                            </>
                          )}
                        </>
                      )}

                      {provided.placeholder}
                    </tbody>
                  )}
                </Droppable> */}
                {this.props.dragandDropAccess ? (
                  <Droppable droppableId="notification-table">
                    {provided => (
                      <tbody
                        ref={provided.innerRef}
                        {...provided.droppableProps}
                        className="users-table-body"
                      >
                        {displayLoader ? (
                          <tr align="center" className="table-loader">
                            <td colSpan="5">
                              <LoaderTemplate />
                            </td>
                          </tr>
                        ) : notificationsData.length === 0 ? (
                          <tr align="center">
                            <td colSpan="5">
                              <NoDataFound />
                            </td>
                          </tr>
                        ) : (
                          notificationsData.map((item, index) => (
                            <Draggable
                              key={item.id || index}
                              draggableId={(item.id || index).toString()}
                              index={index}
                            >
                              {(provided, snapshot) => (
                                <tr
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}
                                  className={
                                    snapshot.isDragging ? "dragging-row" : ""
                                  }
                                  style={provided.draggableProps.style}
                                >
                                  <td className="col-sno">{index + 1}</td>

                                  <td className="col-title">{item.title}</td>

                                  <td className="col-date">
                                    {dateFormat(item.letterdate)}
                                  </td>

                                  <td className="col-file">
                                    <a
                                      href={item.fileUrl}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      {item.filename}
                                    </a>
                                  </td>

                                  <td className="col-action">
                                    <img
                                      src={Edit_Icon}
                                      alt="edit"
                                      className="notifications-edit-icon"
                                      onClick={() => this.onToggleModal(item)}
                                    />

                                    <img
                                      src={Delete_Icon}
                                      alt="delete"
                                      className="notifications-delete-icon"
                                      onClick={e => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        this.onDeleteRecord(item.id, e);
                                      }}
                                    />
                                  </td>
                                </tr>
                              )}
                            </Draggable>
                          ))
                        )}

                        {provided.placeholder}
                      </tbody>
                    )}
                  </Droppable>
                ) : (
                  <tbody className="users-table-body">
                    {displayLoader ? (
                      <tr align="center" className="table-loader">
                        <td colSpan="5">
                          <LoaderTemplate />
                        </td>
                      </tr>
                    ) : notificationsData.length === 0 ? (
                      <tr align="center">
                        <td colSpan="5">
                          <NoDataFound />
                        </td>
                      </tr>
                    ) : (
                      notificationsData.map((item, index) => (
                        <tr key={item.id || index}>
                          <td className="col-sno">{index + 1}</td>

                          <td className="col-title">{item.title}</td>

                          <td className="col-date">
                            {dateFormat(item.letterdate)}
                          </td>

                          <td className="col-file">
                            <a
                              href={item.fileUrl}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {item.filename}
                            </a>
                          </td>

                          <td className="col-action">
                            <img
                              src={Edit_Icon}
                              alt="edit"
                              className="notifications-edit-icon"
                              onClick={() => this.onToggleModal(item)}
                            />

                            <img
                              src={Delete_Icon}
                              alt="delete"
                              className="notifications-delete-icon"
                              onClick={e => {
                                e.preventDefault();
                                e.stopPropagation();
                                this.onDeleteRecord(item.id, e);
                              }}
                            />
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                )}
              </table>
            </DragDropContext>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
